import { action } from 'satcheljs';

export const onFetchTnC = action('onFetchTnC', (locale?: string) => ({ locale }));

export const setNotificationPanelTriggered = action('setNotificationPanelTriggered', (isTrigerred: boolean) => ({ isTrigerred }));
